import { getOpParams } from '../getOpParams';

import { useOpQuery } from './useOpQuery';

export const useAwareDeploymentUrl = (): string | undefined | null => {
  const { orgId } = getOpParams();
  const { data, isLoading } = useOpQuery({
    apiEndpointName: 'listVideoProviders',
    parameters: [orgId],
  });

  if (isLoading) return null;

  const awareVideoProvider = data?.json?.data?.find(
    (provider) => provider.videoProviderTypeId === 5,
  );

  const awareDeploymentUrl = awareVideoProvider?.authState?.serverAddress;

  return awareDeploymentUrl;
};
